// extracted by mini-css-extract-plugin
module.exports = {"MisWrapper":"misrepesentaion_MisWrapper__v0CW9"};